module.exports = __webpack_public_path__ + "img/netdata.a75a97f9.svg";